import { render, staticRenderFns } from "./ValidateList.vue?vue&type=template&id=6b9eac05&"
import script from "./ValidateList.vue?vue&type=script&lang=js&"
export * from "./ValidateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports